import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { LeagueReward } from '../league-reward.model';

@JsonObject('LeagueRewardsResultsResponse')
export class LeagueRewardsResultsResponse extends ApiResultsResponse<LeagueReward> {

  @JsonProperty('results', [LeagueReward])
  override results: LeagueReward[] = [];
}
